// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ap5D","label":"styles_label__3nqmr"};